import classnames from 'classnames'
import React from 'react'
import { IProps } from './index'
import { Image } from 'marketing-site/src/library/elements/Image'
import styles from './styles.scss'

export const CompaniesMarquee = ({ logos }: IProps) => {
  const marqueeClassnames = classnames('companies-marquee')

  return (
    <div className={marqueeClassnames} data-testid="companies-marquee">
      <div className="companies-marquee__logos">
        {logos.map((logo) => (
          <Image url={logo.logoUrl} {...logo} key={logo.logoUrl} testId="logo" />
        ))}
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
